import React from 'react'
import styled from 'styled-components'
import Fade from 'react-reveal/Fade'
import learn from '../images/learn.jpg'

const Learn = () => {

    return (
        <>
		{/* style={{ backgroundImage: `url(${learn})` }} */}
         <Wrap >
			<Box>
			<img className='img' src={learn} />
         <Fade bottom>
			<ItemText>
					<Heading >Learn</Heading>
                     
                     <h2>Whether you’ve never even seen a line of code before or you’ve written full-stack applications that scale, we’ve got you covered. With tech talks, workshops, challenges, and more, there’s plenty of ways to gain new skills and level up your career. Our exciting events, ranging from beginner to advanced, will get you up and running with your first website or how to deploy and auto-scale your application on the cloud.</h2>
				</ItemText>
				
		 
			</Fade>
			</Box>
         </Wrap>
        </>
    );

}

export default Learn;

const Heading = styled.div`
font-size : 80px;
color : green;
`

const Wrap = styled.div `
color: black;
background-color: white;
width: 100vw;
min-height: 100vh;
background-size: cover; /* set size to cover */
background-position: center; /* center the image */
background-repeat: no-repeat; /* dont repeat the background */

display: flex;
flex-direction: row; /* switch to vertical */
justify-content: center; /* horizontal alignment */
align-items: center; /* vertical alignment */

@media (max-width : 768px){
	flex-direction: column;
}

`

const ItemText = styled.div `

padding: 15vh;
text-align: flex-start;
`

const Box = styled.div `
color: black;
background-color: rgb(235, 253, 234) ;
width: 100vw;
height: 80vh;
background-size: cover; /* set size to cover */
background-position: center; /* center the image */
background-repeat: no-repeat; /* dont repeat the background */

display: flex;
flex-direction: row; /* switch to vertical */
justify-content: center; /* horizontal alignment */
align-items: center; /* vertical alignment */

@media (max-width : 768px){
	flex-direction: column;
}

`

